import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, JsonPipe, SlicePipe } from '@angular/common';
import { BaseRules, TextValues } from './alabama-model';
import { UimuiBaseStateComponent } from '../uimui-base-state.component';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-alabama',
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    JsonPipe,
    CommonModule,
    TruncateModule,
    TooltipModule
  ],
  templateUrl: './alabama.component.html',
  styleUrl: './alabama.component.scss',
  host: {
    class: 'state-wrapper',
  },
})
export class AlabamaComponent extends UimuiBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() showValidationError = false;

  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('alabama', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('alabama', null);
    }
  }
  onSelect(selectionId: string, formControlName: string): void {
    if (this.baseRules['selectionId'] === "StateMinimum_VaryBetweenStates") {
      this.reactiveForm.get('levelOne_Radio').setValue('limits_levelone_radio');
    }
  }
}
